class PDPInfoDrawers {
  constructor() {
    this.drawerContainer = document.getElementById('pdp-info-drawer-container');
    if (!this.drawerContainer) return;

    this.drawer = this.drawerContainer.querySelector('.pdp-drawer');
    this.overlay = this.drawerContainer.querySelector('.pdp-drawer-overlay');
    this.closeBtn = this.drawerContainer.querySelector('.drawer-close-btn');
    this.drawerTitle = this.drawerContainer.querySelector('.drawer-title');
    this.drawerContent = this.drawerContainer.querySelector('.canvas-content');

    // 映射：Collapsible row 标题文本 -> template ID
    this.drawerMapping = {
      'Fit & Wear': 'drawer-template-fit_wear',
      'Shipping': 'drawer-template-shipping',
      'Return and Refund': 'drawer-template-return_and_refund',
      'Talk To A Stylist': 'drawer-template-talk_to_a_stylist'
    };

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // 监听所有 Collapsible row 的点击事件
    document.addEventListener('click', (e) => {
      const collapsibleRow = e.target.closest('collapsible-row');
      if (!collapsibleRow) return;

      const detailParent = e.target.closest('.detail-parent');
      if (!detailParent) return;

      // 获取标题文本
      const headingElement = detailParent.querySelector('.heading-color');
      if (!headingElement) return;

      const headingText = headingElement.textContent.trim();

      // 检查是否是我们需要拦截的 Drawer 入口
      if (this.drawerMapping[headingText]) {
        e.preventDefault();
        e.stopPropagation();
        this.openDrawer(headingText);
      }
    });

    // 关闭按钮
    this.closeBtn?.addEventListener('click', () => this.closeDrawer());

    // 点击 Overlay 关闭
    this.overlay?.addEventListener('click', () => this.closeDrawer());

    // ESC 键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isDrawerOpen()) {
        this.closeDrawer();
      }
    });
  }

  openDrawer(headingText) {
    const templateId = this.drawerMapping[headingText];
    const template = document.getElementById(templateId);

    if (!template) {
      console.warn(`[PDPInfoDrawers] Template not found: ${templateId}`);
      return;
    }

    // 获取 template 的 data-drawer-title 属性作为标题
    const drawerTitle = template.getAttribute('data-drawer-title') || headingText;

    // 克隆 template 内容
    const content = template.content.cloneNode(true);

    // 更新 Drawer 标题和内容
    this.drawerTitle.textContent = drawerTitle;
    this.drawerContent.innerHTML = '';
    this.drawerContent.appendChild(content);

    // 显示 Drawer 容器
    this.drawerContainer.style.display = 'block';

    // 触发重排以启用 CSS 过渡动画
    void this.drawerContainer.offsetWidth;

    // 添加打开状态的 class
    this.drawerContainer.classList.add('is-open');
    document.body.classList.add('drawer-open');

    // 将焦点移至 Drawer
    this.drawer.focus();
  }

  closeDrawer() {
    if (!this.isDrawerOpen()) return;

    // 移除打开状态的 class
    this.drawerContainer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');

    // 等待动画完成后隐藏容器
    setTimeout(() => {
      if (!this.isDrawerOpen()) {
        this.drawerContainer.style.display = 'none';
        this.drawerContent.innerHTML = '';
      }
    }, 300); // 与 CSS transition 时间一致
  }

  isDrawerOpen() {
    return this.drawerContainer?.classList.contains('is-open');
  }
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PDPInfoDrawers();
  });
} else {
  new PDPInfoDrawers();
}